<template>
  <div class="mainList">
    <div class="title-top">
      <img src="@assets/images/txt.png" alt="" />
      <span>案例详情</span>
    </div>
    <div class="main-dif" v-for="item in info" :key="item.id">
      <div class="same fl" @click="goMain(item.scode)">
        <img :src="item.ico" alt="" />
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { example } from "@api/common";
import { baseInfo } from "@utils/config.js";

export default {
  data() {
    return {
      info: []
    };
  },
  created() {
    this.getDataInfo();
    // this.getWidthId();
  },
  methods: {
    getDataInfo() {
      example({ type: 1 }).then(res => {
        // console.log("我是案例详情：", res);
        this.info = res.data.data;
      });
    },
    goMain(id) {
      // console.log(id);
      this.$router.push({ path: "/case", query: { aid: id } });
    }
  },
  computed: {
    getWebSoketDomain() {
      return baseInfo.webSoketDomain;
    }
  }
};
</script>
<style lang="scss" scoped>
.mainList {
  padding: 1rem 0.25rem;
  background-color: #fff;
  height: 100%;
  .title-top {
    margin-top: 0.2rem;
    img {
      width: 3.5%;
      height: 1.6%;
      vertical-align: bottom;
    }
    span {
      color: #3bbb61;
      font-size: 0.25rem;
      margin-left: 0.1rem;
    }
  }
  .same {
    width: 47%;
    height: 2rem;
    margin-top: 0.3rem;
    margin-right: 0.2rem;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    p {
      color: #fff;
      font-size: 16px;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      font-family: SourceHanSansCN-Regular;
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
  .fl {
    float: left;
  }
  .one {
    width: 60%;
    height: 2rem;
  }
  .two {
    width: 37%;
    height: 2rem;
  }
  .three {
    width: 47%;
  }
}
</style>
